import Modal from "../lib/modals";

export default class GalleryModal {
  constructor(el) {
    this.el = el;

    if (!this.el) {
      return false;
    }

    this.modalEl = this.el.querySelector(".ShareYourVisionGalleryItem-modal");
    this.modal = new Modal(this.modalEl);
    this.modalToggleBtn = this.el.querySelector(".ShareYourVisionGalleryItem-modalButton");

    if (this.modalEl && this.modal && this.modalToggleBtn) {
      this.init();
    }

    // when closing the modal reset all the iframes to prevent videos and audio from playing in the background
    this.iframes = this.el.querySelectorAll('iframe');
    this.modal.on('close', () => {
      this.iframes.forEach((iframe) => {
        iframe.setAttribute('src', iframe.getAttribute('src'))
      })
    })
  }

  init() {
    this.modalToggleBtn.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(evt) {
    evt.preventDefault();
    this.modalEl.setAttribute('aria-hidden', 'false');
  }
}

const galleryItems = document.querySelectorAll('.ShareYourVisionGalleryItem');
console.log("Initializing GalleryModal for items:", galleryItems.length);

galleryItems.forEach((item) => {
  new GalleryModal(item);
});
